// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__YR3u7","colMin":"styles_colMin__3dnbe","colCheckbox":"styles_colCheckbox__1UX8h"};